"use client";
import Header from "../../../components/admin/common/Header";
import PageWrapper from "../../../components/admin/common/PageWrapper";
import Sidebar from "../../../components/admin/common/Sidebar";
import EditEventForms from "../../../components/admin/events/EditEventForms";

const EditEvent = () => {
  return (
    <div className="flex h-screen p-4 gap-4 bg-white overflow-hidden">
      {/* Sidebar - fixed, never scrolls */}
      <div className="h-full w-[250px] flex-shrink-0">
        <div className="sticky top-0 h-full">
          <Sidebar />
        </div>
      </div>

      {/* Right-side main content - scrollable */}
      <div className="flex-1 h-full bg-[#F3EFFF] rounded-[27px] flex flex-col overflow-auto">
        <PageWrapper className="flex flex-col flex-1 min-h-0">
          {/* Scrollable area inside */}
          <div className="flex-1 overflow-y-auto p-4 min-h-0">
            <Header title="Edit Events" desc="Edit and manage events" />
            <EditEventForms />
          </div>
        </PageWrapper>
      </div>
    </div>
  );
};

export default EditEvent;
